<template>
  <div class="list_view style_new bg-white exhibit-card mb-3">

    <div class="exhibit-content">

      <h2 class="exhibit-title">
        {{ exhibit?.name }}
      </h2>

      <p class="exhibit-description"
         v-html="exhibit?.description || ''">
      </p>

      <div class="exhibit-meta">
        <span>
          {{ $t('start at') }} :
          {{ exhibit?.start_date }}
        </span>

        <span>
          {{ $t('and end at') }} :
          {{ exhibit?.end_date }}
        </span>

        <span>
          {{ $t('number of halls') }} :
          {{ exhibit?.halls_count }}
        </span>
      </div>

      <!-- Halls -->
      <div class="halls-section">
        <div
            v-for="hall in exhibit?.halls || []"
            :key="hall.id"
            class="hall-item"
        >
          {{ hall.name }}
          —
          {{ $t('number of stands') }} :
          {{ hall.stands_count }}
        </div>
      </div>

      <!-- Map Image -->
      <div v-if="exhibit?.mapImage" class="map-section">

        <h4 class="section-title">
          {{ $t('exhibit map') }}
        </h4>

        <img
            :src="exhibit.mapImage"
            class="mapImage"
            alt="Exhibit Map"
            loading="lazy"
            @error="handleImageError"
        />

      </div>

      <!-- Visitor -->
      <p class="visitor-box">
        <strong>{{ $t('Visitor Count') }} :</strong>
        {{ visitorCount || 0 }}
      </p>

      <!-- Tags -->
      <div class="tags-row">
        <strong>{{ $t('Tags') }} :</strong>

        <span
            v-for="tag in exhibit?.tags || []"
            :key="tag.id"
            class="tag-item"
        >
          {{ tag.name }}
        </span>
      </div>

      <!-- Categories -->
      <div class="tags-row mt-3">
        <strong>{{ $t('Categories') }} :</strong>

        <span
            v-for="rating in exhibit?.ratings || []"
            :key="rating.id"
            class="tag-item"
        >
          {{ rating.name }}
        </span>
      </div>

    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue"

defineProps({
  exhibit: Object,
  border: Boolean,
  visitorCount: Number
})
function handleImageError(e) {
  e.target.style.display = "none"
}
</script>

<style scoped>
.exhibit-card {
  border-radius: 22px;
  padding: 28px;
  box-shadow: 0 2px 18px rgba(0,0,0,0.05);
}

.exhibit-title {
  font-weight: 700;
  margin-bottom: 16px;
}

.exhibit-description {
  line-height: 1.7;
  color: #555;
}

.exhibit-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 0.95rem;
  margin: 18px 0;
}

.halls-section {
  margin-top: 20px;
}

.hall-item {
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 10px;
  margin-bottom: 6px;
}

.map-section {
  margin-top: 28px;
}

.section-title {
  margin-bottom: 12px;
}

.mapImage {
  width: 100%;
  max-width: 550px;
  border-radius: 18px;
  object-fit: cover;
  transition: 0.3s ease;
}

.mapImage:hover {
  transform: scale(1.01);
}

.visitor-box {
  margin-top: 22px;
  font-size: 1rem;
}

.tags-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-top: 18px;
}

.tag-item {
  background: linear-gradient(135deg,#C48B6E,#a86a4b);
  color: white;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.85rem;
}
</style>